export const locale = {
    id: 'de-DE',
    prefix: '',
    mailDomain: 'de',
};
